import { ref } from 'vue';

type ConfirmState = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  destructive: boolean;
  resolve: ((ok: boolean) => void) | null;
};

const state = ref<ConfirmState>({
  open: false,
  title: '',
  message: '',
  confirmLabel: 'Confirm',
  destructive: false,
  resolve: null,
});

export function useConfirm() {
  function confirm(opts: {
    title?: string;
    message: string;
    confirmLabel?: string;
    destructive?: boolean;
  }): Promise<boolean> {
    return new Promise((resolve) => {
      state.value = {
        open: true,
        title: opts.title ?? 'Confirm',
        message: opts.message,
        confirmLabel: opts.confirmLabel ?? 'Confirm',
        destructive: opts.destructive ?? false,
        resolve,
      };
    });
  }

  function answer(ok: boolean): void {
    state.value.resolve?.(ok);
    state.value = { ...state.value, open: false, resolve: null };
  }

  return { state, confirm, answer };
}
